var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"btn-wrapper d-flex justify-content-md-end justify-content-center"},[_c('button',{staticClass:"btn btn-primary wizard-btn next-btn mr-3",on:{"click":function($event){return _vm.$emit('input', 'REGIE')}}},[_vm._v("\n      Nouveau Retour De Régie\n    ")])]),_c('div',{staticClass:"mt-3"},[_c('history-demands')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }